import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Card, CardBody, CardFooter,Row, Col, Progress, Table, Badge,Nav,NavItem, TabContent,TabPane,NavLink} from "reactstrap";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

const propTypes = {
    MeterAmpsA : PropTypes.number,
    MeterAmpsB : PropTypes.number,
    MeterAmpsC : PropTypes.number,
    MeterVoltsAB : PropTypes.number,
    MeterVoltsBC : PropTypes.number,
    MeterVoltsCA : PropTypes.number,
    MeterKw : PropTypes.number,
    MeterKvar : PropTypes.number,
    MeterKva : PropTypes.number,
    MeterFreq : PropTypes.number,
    MeterPf : PropTypes.number,
    MeterSpare1 : PropTypes.number,
    MeterSpare2 : PropTypes.number,
    MeterSpare3 : PropTypes.number,
    MeterSpare4 : PropTypes.number,
    systemStatus : PropTypes.array,

};

const defaultProps = {
    header: '$1,999.50',
    mainText: 'Income',
    icon: "fa fa-cogs",
    color: 'primary',
    variant: "0",
    link: "#",
    Voltage:4160,
    MeterAmpsA  : 0 ,
    MeterAmpsB  : 0 ,
    MeterAmpsC  : 0 ,
    MeterVoltsAB  : 0 ,
    MeterVoltsBC  : 0 ,
    MeterVoltsCA  : 0 ,
    MeterKw  : 0 ,
    MeterKvar  : 0 ,
    MeterKva  : 0 ,
    MeterFreq  : 0 ,
    MeterPf  : 0 ,
    MeterSpare1  : 0 ,
    MeterSpare2  : 0 ,
    MeterSpare3  : 0 ,
    MeterSpare4  : 0 ,
    systemStatus : [],

};




class System extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        const {Voltage,
            MeterAmpsA ,
            MeterAmpsB ,
            MeterAmpsC ,
            MeterVoltsAB ,
            MeterVoltsBC ,
            MeterVoltsCA ,
            MeterKw ,
            MeterKvar ,
            MeterKva ,
            MeterFreq ,
            MeterPf ,
            MeterSpare1 ,
            MeterSpare2 ,
            MeterSpare3 ,
            MeterSpare4 ,
            systemStatus,
            className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        // demo purposes only
        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-black-50', padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-' + card.color, padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        const cardFooter = function () {
            if (footer) {
                return (
                    <CardFooter className="px-3 py-2">
                        <a className="font-weight-bold font-xs btn-block text-muted" href={link}>View More
                            <i className="fa fa-angle-right float-right font-lg"></i></a>
                    </CardFooter>
                );
            }
        };
        return (
            <Card>
                <CardBody className={ card.classes } {...attributes}>
                    <div className={ lead.classes }>{ header }</div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">{ mainText }</div>
                    <Row>
                    <Col xs="12" sm="12" lg="6">
                        <hr />
                        <Row>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">Voltage Avg</div>
                            </Col>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-black-50 font-xs font-weight-bold">{ Math.round((MeterVoltsAB + MeterVoltsBC + MeterVoltsCA) / 3) }</div>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">Amps Avg</div>
                            </Col>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-black-50 font-xs font-weight-bold">{ Math.round((MeterAmpsA + MeterAmpsB + MeterAmpsC) / 3 )}</div>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">Freq</div>
                            </Col>
                            <Col xs="6" sm="6" lg="6">
                                <div className="text-black-50 font-xs font-weight-bold">{ MeterFreq / 100}</div>
                            </Col>
                        </Row>
                        <hr />
                    </Col>
                        <Col xs="12" sm="12" lg="6">
                            <hr className="d-sm-none d-lg-block" />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Pf</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterPf }</div>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Kw</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterKw }</div>
                                </Col>
                            </Row>
                            <hr />

                            <Row>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-muted text-uppercase font-weight-normal font-xs">Kvar</div>
                                </Col>
                                <Col xs="6" sm="6" lg="6">
                                    <div className="text-black-50 font-xs font-weight-bold">{ MeterKvar }</div>
                                </Col>
                            </Row>
                            <hr />
                        </Col>
                    </Row>


                </CardBody>
                { cardFooter() }
            </Card>
        )
    }
}

System.propTypes = propTypes;
System.defaultProps = defaultProps;

export default System;


// WEBPACK FOOTER //
// ./src/views/site/SystemSchema/System.js